// function to trim and capitalize the full value
export const trimAndCapitalize = (value: string): string => {
    if (!value) return "";
    return value.trim().toUpperCase();
};